<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title">{{ info?.tellAboutFundraiser }}</mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content>
  <div class="d-flex justify-content-center mt-2" *ngIf="!campaignService?.micrositeCampaigns?.entity_id">
    <div class="mr-2">
      <img loading="lazy" data-src="/assets/images/globe.png" alt="Medical">
    </div>
    <div class="d-flex flex-column align-items-start">
      <div *ngIf="util.storage.get('language') === 'Hindi' ; else raisingFundsFor">
        <div class="line-height-30" >
          <b>{{ frType === 'ngo' ? 'एनजीओ/दान पुण्य' : 'अन्य' }}</b> उद्देश्य के लिए धन जुटाना
        </div>
      </div>
      <span class="style-as-link" (click)="openChangePurpose()" *ngIf="!draft">{{info?.change_purpose}}?</span>
    </div>
  </div>
  <form class="form-container m-10" [formGroup]="basicForm" (ngSubmit)="basic()" autocomplete="off">
    <app-input class="app-input" inputType="number"
              [control]="amount_requested"
              [group]="basicForm"
              [placeHolder]="info?.amount?.placeholder"
              icon="icon-help"
              [hint]="info?.amount?.hint"
              [info]="info?.amount?.popover"
              preIcon="icon-rupee"
              [errorMessage]="info?.amount?.error" >
    </app-input>
    <app-input class="app-input" inputType="text"
                [control]="title"
                [group]="basicForm"
                [placeHolder]="info?.title?.placeholder"
                icon="icon-help"
                hintLength="75"
                [info]="info?.title?.popover"
                [errorMessage]="info?.title?.error" >
    </app-input>
    <div [hidden]="frType === 'ngo'">
      <app-select [placeHolder]="info?.relation?.placeholder"
                  [group]="basicForm"
                  [control]="relation"
                  (onChange)="selectRelation($event)"
                  [data]="parentCauses"
                  [errorMessage]="info?.relation?.error">
      </app-select>
    </div>
    <div *ngIf="frType !== 'ngo' && relation.value && relation.value !=='myself'">
      <app-input
      inputType="text"
      [control]="beneficiaryname"
      [group]="basicForm"
      [placeHolder]="info?.beneficiaryname?.placeholder"
      [info]="info?.beneficiaryname?.popover"
      icon="icon-help"
      [errorMessage]="info?.beneficiaryname?.error" >
    </app-input>
  </div>
  <app-autoselect *ngIf="frType === 'ngo'" [group]="basicForm"
                  [id]="'ngoSelectInput'"
                  [control]="ngo"
                  [data]="ngos"
                  (onInput)="onNgoInput($event)"
                  (onSelect)="onNgoSelect($event)"
                  [label]="info?.ngo?.placeholder"
                  [fieldRequired]="info?.fieldRequired"
                  icon="icon-help"
                  [hidden]="campaignService?.micrositeCampaigns?.entity_type === 'ngo'">
  </app-autoselect>
  <app-select *ngIf="causes" [placeHolder]="info?.cause?.placeholder"
  [group]="basicForm"
  [control]="cause_id"
  [data]="causes"
  (onChange)="onCauseSelect($event)"
  [errorMessage]="info?.cause?.error"
  >
</app-select>

  <div *ngIf="basicForm" class="campaigner-details">
    <mat-form-field class="mt-2">
      <mat-label>{{ info?.qualification }}</mat-label>
      <mat-select [formControl]="qualification">
        <mat-option *ngFor="let item of qualificationList" [value]="item.key">
          {{ item.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="qualification.hasError('required') && qualification.touched">{{info?.fieldRequired}}</mat-error>
    </mat-form-field>

    <mat-form-field class="mt-2">
      <mat-label>{{ info?.occupation }}</mat-label>
      <mat-select [formControl]="occupation">
        <mat-option *ngFor="let item of occupationList" [value]="item.key">
          {{ item.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="occupation.hasError('required') && occupation.touched">{{info?.fieldRequired}}</mat-error>
    </mat-form-field>
  </div>

<app-intl-input
*ngIf="askCampaignerPhone"
class="intl-input-container"
[group]="basicForm"
[control]="campaignerPhone"
[hideSuffixIcon]="false">
</app-intl-input>
<app-select *ngIf="brandSurveyData" [placeHolder]="info?.survey?.placeholder"
  [group]="basicForm"
  [control]="survey"
  [data]="brandSurveyData"
  (onChange)="onSurveySelect($event)"
  [errorMessage]="info?.survey?.error"
  >
</app-select>
<!-- <re-captcha *ngIf="showCaptcha" #captchaRef="reCaptcha" class="g-recaptcha" size="invisible" (resolved)="resolved($event)"></re-captcha> -->
    <re-captcha *ngIf="showCaptcha" #captchaRef="reCaptcha" class="g-recaptcha" (resolved)="resolved($event)"></re-captcha>
    <button id="submitBtn1" style="display: none" ></button>
    <span class="bottom-text">{{info?.change_easily}} </span>
  </form>
  <div class="no-charges">
    {{info?.ketto_zero_fee}}
  </div>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <!-- <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()">SAVE AND CONTINUE</button> -->
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="isLoading">
    <div class="button-wrapper" *ngIf="!isLoading" >
      {{info?.save_and_continue}}
    </div>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</mat-card-footer>
<ng-template #raisingFundsFor>
  <div>{{ info?.raising_funds_for }}<b> {{ frType === 'ngo' ? info?.ngo_charity : info?.other }} </b> {{ info?.purposeText }}</div>
</ng-template>
